export default __webpack_public_path__ + "static/media/uploader-roche-problem-2.2bd089cb.png";